import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider, Stack } from "@mui/material";

const styles = {
  container: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  divider: {
    height: "1rem",
  },
  button: {
    minWidth: "auto",
    height: "auto",
    p: "0.25rem 0.5rem !important",
  },
}

const highlight = (active: boolean) => (active ? "var(--color-primary)" : "var(--color-grey-500)");

const Languages = () => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage;

  const changeLanguage = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const lng = e.currentTarget.dataset.language;
      if (language !== lng) {
        i18n.changeLanguage(lng);
      }
    },
    [language],
  );

  return (
    <Stack sx={styles.container}>
      <Button variant="text" data-language="en_US" onClick={changeLanguage} sx={{ ...styles.button, color: highlight(language === "en_US") }}>
        EN
      </Button>
      <Divider orientation="vertical" sx={styles.divider} />
      <Button variant="text" data-language="de_DE" onClick={changeLanguage} sx={{ ...styles.button, color: highlight(language === "de_DE") }}>
        DE
      </Button>
      {/* <Divider orientation="vertical" sx={styles.divider} />
      <Button variant="text" data-language="fr_FR" onClick={changeLanguage} sx={{ ...styles.button, color: highlight(language === "fr_FR") }}>
        FR
      </Button> */}
    </Stack>
  );
};

export default Languages;
